import { getFromServerToken, postToServerToken } from './fetch'
import { useState, useContext } from 'react';
import { displayCapnr } from '../components/helperFunctions';
import EventContext from "../store/event-context";
import { orderBy } from 'natural-orderby';

const useWave = () => {
    const [isLoadingWave, setIsLoading] = useState(false);
    const [waveData, setWaveData] = useState({});
    const [wavesData, setWavesData] = useState([]);
    const [waveServerError, setServerError] = useState(null);
    const eventctx = useContext(EventContext);

    const addActorRow = (actor) => {
        console.log("addActorRow - actor", actor, " waveData: ", waveData);
        if (actor === undefined || actor.id === undefined) {
            return;
        }
        if (waveData !== undefined && waveData.length > 0 && waveData[0].id === actor.id) {
            // Already actor in waveData - No need to fill first row
            // console.log("addActorRow - waveData already filled with the correct actor row: ", waveData);
            return;
        }
        let tmpData = [];
        // If there are more rows, remove the actor row
        if (Object.keys(waveData).length > 0) {
            tmpData = waveData.filter( item => item.id !== actor.id);
        }
        // Prepare the actor row
        if (actor.state === "registered" || actor.state === "initial") {
            actor.state = "ready";
            actorStateChange (actor.id, "ready");
        }

        const fullName = actor.firstName + " " + actor.lastName;
        const displayWave = "Wave: " + actor.wave
        const actorRow = [{
            id: actor.id,
            capnr: actor.capnr,
            displayCapnr: displayCapnr(actor.capnr, eventctx.event.colors),
            fullName: fullName,
            state: actor.state,
            teamName: actor.teamName,
            displayWave: displayWave
            }];
        // Put actor row on the first line ofa wave data
        tmpData = actorRow.concat(tmpData);
        console.log("addActorRow - setWaveData: ", tmpData);
        setWaveData(tmpData);
    }


    const fetchActorByWave = async (waveName) => {
        console.log("Fetching wave with name: " + waveName)

        setIsLoading(true)
        const { data, status } = await getFromServerToken(`/events/${eventctx.eventId}/waves/${waveName}`)

        if (status === 404) {
            setServerError(`Wave ${waveName} bestaat niet of de deelnemers hebben al gezwommen`)
            setWaveData({})
        } else if (status !== 200) {
            setServerError(data.detail)
            setWaveData({})
        } else {
            console.log("Wave fetched: ", data.actors);
            let tmpData = data.actors.map((actor) => {
                actor.fullName = actor.firstName + " " + actor.lastName;
                actor.displayCapnr = displayCapnr(actor.capnr, eventctx.event.colors);
                actor.displayWave = "Wave: " + actor.wave;
                return actor;
            });
            
            const sorted = orderBy(tmpData,
                [a => a.displayCapnr, a=> a.fullName], ['asc', 'asc']);
            setWaveData(sorted);
            setServerError("");

        }
        setIsLoading(false)
    }

    const fetchWaves = async () => {

        console.log("Fetching a list of all waves")
        const { data, status } = await getFromServerToken(`/events/${eventctx.eventId}/waves`)

        if (status !== 200) {
            setServerError(data.detail)
            setWavesData({})
        } else {
            console.log("Waves fetched: ", data);
            var sorted = orderBy(data.waves, [a => a.waveName, a => a.event], ['asc', 'asc']);
            setWavesData([...sorted]);
        }
    }

    const countReady = () => {
        //console.log("CountReady - waveData: ", waveData);
        let result = 0;
        if (Object.keys(waveData).length > 0) {
            result = waveData.filter(actor => actor.state === "ready").length;
        }
        return result;
    }

    const toggleReady = (id, currentState, changeYN) => {
        console.log("Toggle capnr (ready vs not ready) - ID: ", id, "Current state: ", currentState);
        let doChange = true;
        if (currentState === "busy") {
            doChange = changeYN;                    // Handle in calling component(s)
        //    doChange = window.confirm("Deze zwemmer is al IN het water gemeld.\n\n" +
        //                        "Klik op OK om toch (opnieuw) in het water te melden.\n" +
        //                        "Klik op Annuleren om deze foute rij van het scherm te verijderen.");
        } else if (currentState === "done") {
            //window.alert("Zwemmer is al helemaal klaar en UIT het water gemeld.\n\n" +
            //             "Gebruik (indien nodig) het 'Uit het water'-scherm om dit terug te draaien.");
            doChange = false;
        } else if (currentState !== "ready" && currentState !== "registered" && currentState !== "initial") {
            setServerError("Status van deze zwemmer klopt niet!\nRij wordt van het scherm verwijderd.")
            doChange = false;
        }
        console.log("List before changing actor with id: ", id, " - ", waveData);
        console.log("dochange : ", doChange, " changeYN : ", changeYN);

        if (doChange && changeYN) {
            let newData = waveData.map((item) => {
                if (item.id === id && doChange) {
                    if (item.state === 'ready') {
                        item.state = 'registered';
                        actorStateChange (item.id, 'undo');
                    } else if (item.state === 'registered') {
                        item.state = 'ready';
                        actorStateChange (item.id, 'ready');
                    } else if (item.state === 'busy') {
                        item.state = 'ready';
                        actorStateChange (item.id, 'undo');
                    } else {
                        item.state = 'ready';
                        actorStateChange (item.id, 'ready');
                    }
                }
                return item;
            });
            setWaveData(newData);
        } else if (changeYN) {
            // Remove the row with the given id
            let newData = waveData.filter(actor => actor.id !== id);
            setWaveData(newData);
            console.log("List after changing actor with id: ", id, " - ", newData);
        }
    }

    const actorStateChange = async (id, state) => {
        console.log("actorStateChange - id: ", id, " - state: ", state);
        // this one requires no body
        setIsLoading(true)
        const url = "/events/" + eventctx.eventId + "/actors/" + id + "/" + state;
        const { data, status } = await postToServerToken(url, {})

        if (status === 404) {
            setServerError("Wijzing is mislukt, de zwemmer is niet gevonden")
            //setWaveData({})
        } else if (status !== 200) {
            setServerError(data.detail);
            //setWaveData({})
        } else {
            console.log("Actors changed state: ", data);
            //setWaveData(data)
            setServerError("")
        }
        setIsLoading(false)
    }

    // *****************************************************
    // To be DOne
    // If one line has been adjusted, all lines need to be 
    // synced with the server. We might build in a refresh
    //
    // *****************************************************

    const waveToStart = async () => {
        // Set everyone in the table to 'busy' that is now on 'ready'.
        // Post API Url: /events/<evenId>/update/busy
        // Body: Dict with field actors and in there a list with capnrs.

        if (Object.keys(waveData).length === 0) {
            return;
        }

        const url = "/events/" + eventctx.eventId + "/update/busy";
        const capnrs = waveData.filter(actor => actor.state === "ready").map((item) => {
            return item.capnr;
        });

        if (capnrs.length > 0) {
            const body = `{"actors": "${capnrs}"}`
            console.log("Body: ",body);

            setIsLoading(true);
            const { data, status } = await postToServerToken(url, body);
            console.log(data);
            if (status >= 400) {
                setServerError(data.detail);
            } else {
                setServerError("");
                setWaveData({});
            }
            setIsLoading(false);
        }
    }

    const goWave = ( resetActor ) => {
        console.log("Go wave function called");
        if (Object.keys(waveData).length === 0) {
        //if (!waveData || (waveData && waveData.length === 0)) {
            // setServerError("Geen zwemmers geselecteerd.");
        } else {
            waveToStart();
            setWaveData({});
            resetActor();
        }
    }

    return { waveData, wavesData, countReady, isLoadingWave, waveServerError, addActorRow, fetchWaves, fetchActorByWave, toggleReady, goWave };
}

export default useWave

